module.exports = __webpack_public_path__ + "static/media/bogdan_prilepa.5c907460.jpg";